module.exports = __webpack_public_path__ + "img/hk-back.6812a680.png";